/**
 * Data Layer: Book cover image mapping (vertical / portrait edition)
 * Maps book names to their cover image URLs (3:4 portrait ratio).
 * Pure data — no logic, no state.
 */
const BOOK_COVERS = {
  '枪炮病菌与钢铁': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstxtcjabi_ve_miaoda',
  '被讨厌的勇气': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstx3bjyci_ve_miaoda',
  '活着': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstypvfyio_ve_miaoda',
  '人类简史': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstynxxieq_ve_miaoda',
  '三体': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstxtcjaai_ve_miaoda',
  '月亮与六便士': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstynsbyig_ve_miaoda',
  '你当像鸟飞往你的山': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksty7oxwao_ve_miaoda',
  '人形机器人产业标准体系建设指南（2026 版）': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkst2kydqci_ve_miaoda',
  '创新者的窘境': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadkstxzfn4io_ve_miaoda',
  '刻意练习': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksueotkwks_ve_miaoda',
  '未来简史': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksudpduihu_ve_miaoda',
  '简爱': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksubjqosew_ve_miaoda',
  '短剧/影视解说出海': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksutlwz2mg_ve_miaoda',
  '团播乱象治理': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksutbcrgcq_ve_miaoda',
  '长尾理论': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksyr4kgetw_ve_miaoda',
  '过滤泡': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksytf4yirs_ve_miaoda',
  '人机对齐': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadksys65mwbs_ve_miaoda',
  '思考快与慢': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadks34ghuacu_ve_miaoda',
  '牛奶可乐经济学': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadks4ewljsbu_ve_miaoda',
  '从优秀到卓越': '/spark/app/app_17d4arbjrae/runtime/api/v1/storage/object/bucket_aadksprci2mgg_static/static%2Faadks37qv6kgw_ve_miaoda',
};

/**
 * Get cover image URL for a book.
 * Falls back to empty string if no cover exists.
 * @param {string} bookName
 * @returns {string} image URL or ''
 */
function getBookCover(bookName) {
  return BOOK_COVERS[bookName] || '';
}

window.BOOK_COVERS = BOOK_COVERS;
window.getBookCover = getBookCover;

export { BOOK_COVERS, getBookCover };
